import React from "react";
import img01 from "../../assets/img/images/about_img01.png";
import { Link } from "react-router-dom";

const WhoWeAre = (props) => {
  return (
    <section id="about" className="about-area pt-130 pb-130">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
              <img src={img01} alt="About Us" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content wow fadeInRight" data-wow-delay=".2s">
              <div className="section-title mb-30">
                <span className="sub-title">Who we are</span>
                <h2 className="title">
                  The World’s <span>1st</span> smart mining platform powered by <span>XMH</span>,
                   offering automated profit optimization and <span>NFT</span>-based mining rewards."
                </h2>
              </div>
              <p>
              XMH is more than just a cryptocurrency; it's a game-changer in smart mining. With a focus on sustainability,
               profitability, and innovation, we are laying the foundation for the future of decentralized mining.
                Join the revolution – become part of XMiningHub today!
              </p>

              {/* زر يوجه إلى صفحة /wp */}
              <Link to="/wp" className="btn">
                White Paper
              </Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;